module.exports = __webpack_public_path__ + "static/AkkuratPro-Regular-49efe2041d5877b7fc46c5386b83649a.woff";